import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "../utils/styleHelper";
import { Calendar } from "./Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
export function DateRangeInputs({ startDate, endDate, onStartDateChange, onEndDateChange, startPlaceholder = "Start date", endPlaceholder = "End date", disabled = false, className }) {
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const handleStartDateSelect = (date)=>{
        if (date && endDate && date > endDate) {
            onStartDateChange?.(endDate);
            onEndDateChange?.(date);
        } else {
            onStartDateChange?.(date);
        }
    };
    const handleEndDateSelect = (date)=>{
        if (date && startDate && date < startDate) {
            onStartDateChange?.(date);
            onEndDateChange?.(startDate);
        } else {
            onEndDateChange?.(date);
        }
    };
    const modifiers = {};
    const modifiersClassNames = {};
    if (startDate && endDate) {
        if (startDate.getTime() !== endDate.getTime()) {
            modifiers["range_start"] = startDate;
            modifiersClassNames["range_start"] = "bg-navy-90 text-white hover:bg-navy-90 hover:text-white rounded-l-md";
            modifiers["range_end"] = endDate;
            modifiersClassNames["range_end"] = "bg-navy-90 text-white hover:bg-navy-90 hover:text-white rounded-r-md";
            modifiers["range_middle"] = {
                after: startDate,
                before: endDate
            };
            modifiersClassNames["range_middle"] = "bg-navy-20 text-navy-90 hover:bg-navy-50 hover:text-navy-90";
        } else {
            modifiers["range_start"] = startDate;
            modifiersClassNames["range_start"] = "bg-navy-90 text-white hover:bg-navy-90 hover:text-white";
        }
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex gap-4", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1",
                children: /*#__PURE__*/ _jsxs(Popover, {
                    open: isStartOpen,
                    onOpenChange: setIsStartOpen,
                    children: [
                        /*#__PURE__*/ _jsx(PopoverTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsxs("button", {
                                type: "button",
                                disabled: disabled,
                                className: cn("w-full h-11 px-4 py-2.5 sm:h-9 sm:px-3 sm:py-1.5 text-sm leading-5 bg-white border border-gray-300 rounded-lg text-left font-normal flex items-center gap-2", "shadow-sm transition-all duration-200 hover:border-gray-400", "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500", !startDate && "text-gray-500", "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50"),
                                children: [
                                    /*#__PURE__*/ _jsx(CalendarIcon, {
                                        className: "h-4 w-4 flex-shrink-0 text-gray-400"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "flex-1",
                                        children: startDate ? format(startDate, "PPP") : startPlaceholder
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(PopoverContent, {
                            className: "w-auto p-0",
                            align: "start",
                            children: /*#__PURE__*/ _jsx(Calendar, {
                                mode: "single",
                                required: false,
                                selected: startDate,
                                onSelect: handleStartDateSelect,
                                ...startDate ? {
                                    defaultMonth: startDate
                                } : endDate ? {
                                    defaultMonth: endDate
                                } : {},
                                modifiers: modifiers,
                                modifiersClassNames: modifiersClassNames
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1",
                children: /*#__PURE__*/ _jsxs(Popover, {
                    open: isEndOpen,
                    onOpenChange: setIsEndOpen,
                    children: [
                        /*#__PURE__*/ _jsx(PopoverTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsxs("button", {
                                type: "button",
                                disabled: disabled,
                                className: cn("w-full h-11 px-4 py-2.5 sm:h-9 sm:px-3 sm:py-1.5 text-sm leading-5 bg-white border border-gray-300 rounded-lg text-left font-normal flex items-center gap-2", "shadow-sm transition-all duration-200 hover:border-gray-400", "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500", !endDate && "text-gray-500", "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50"),
                                children: [
                                    /*#__PURE__*/ _jsx(CalendarIcon, {
                                        className: "h-4 w-4 flex-shrink-0 text-gray-400"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "flex-1",
                                        children: endDate ? format(endDate, "PPP") : endPlaceholder
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(PopoverContent, {
                            className: "w-auto p-0",
                            align: "start",
                            children: /*#__PURE__*/ _jsx(Calendar, {
                                mode: "single",
                                required: false,
                                selected: endDate,
                                onSelect: handleEndDateSelect,
                                ...endDate ? {
                                    defaultMonth: endDate
                                } : startDate ? {
                                    defaultMonth: startDate
                                } : {},
                                modifiers: modifiers,
                                modifiersClassNames: modifiersClassNames
                            })
                        })
                    ]
                })
            })
        ]
    });
}
